import { useEffect, useState } from "react";
import { Button } from "../../../../components/buttons/button";
import { PopoverMenu } from "../../../../components/dropdown/popover";
import { CaretDown } from "../../../../components/icon/downcaret";
import { Icon } from "../../../../components/icon/icon";
import { FindEventsFilterModal } from "../../../../components/modal/app_modals/findEventsFilterModal";
import { useModalControl } from "../../../../customeHooks/useModalControl";
import { useWindowDimensions } from "../../../../customeHooks/useWindowDimensions";
import {
  EventPriceFilterOption,
  FindEventsQuery,
} from "../../../../redux/features/event/event.types";
import { currencyPriceFilters } from "../../../../utils/constants";

export const PriceFilter = ({
  query,
  setQuery,
}: {
  query: FindEventsQuery;
  setQuery: (q: FindEventsQuery) => void;
}) => {
  const [priceFilters, setPriceFilters] = useState<
    { name: string; value: string; onClick: () => void }[]
  >([]);

  const { handleModalClose, handleModalOpen, modal, modalOpen } =
    useModalControl();

  const { width } = useWindowDimensions();

  useEffect(() => {
    setPriceFilters(
      currencyPriceFilters[query.country ?? "Nigeria"].map((i) => ({
        name: i.title,
        value: i.value,
        onClick: () => {
          setQuery({
            ...query,
            category: undefined,
            page: 1,
            price: i.value as EventPriceFilterOption,
          });
        },
      })),
    );
    // eslint-disable-next-line
  }, [query.country]);

  return (
    <>
      <PopoverMenu
        menuItems={priceFilters}
        menuClassName="!min-w-[177px] !w-max !rounded-xl !hidden md:!flex"
        menuItemsClassName="!text-grey-950 !font-bold"
        position="bottom start"
        closeOnClick
        className="min-w-max"
      >
        {({ open }) => (
          <Button
            type="button"
            text={
              query.price && query.price !== "free"
                ? priceFilters.find((pf) => pf.value === query.price)?.name!
                : `Price`
            }
            variation="plain-text-grey"
            icon="ticket"
            iconDimension={20}
            extra={
              query.price && query.price !== "free" ? (
                <p
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setQuery({
                      ...query,
                      price: undefined,
                      page: 1,
                    });
                  }}
                >
                  <Icon
                    svg="close-icon"
                    width={20}
                    height={20}
                    className="text-grey-600"
                  />{" "}
                </p>
              ) : (
                <CaretDown width={20} height={20} />
              )
            }
            className={`${open || (query.price && query.price !== "free") ? "!border-[2px] !border-primary" : ""} `}
            onClick={
              width < 768
                ? () => {
                    handleModalOpen("priceFilterModal");
                  }
                : undefined
            }
          />
        )}
      </PopoverMenu>

      <FindEventsFilterModal
        open={modalOpen && modal === "priceFilterModal"}
        handleClose={() => {
          handleModalClose();
        }}
        title="Filter by price"
      >
        <div className="flex flex-col">
          {priceFilters.map((item, idx) => {
            return (
              <button
                type="button"
                className="w-full border-b border-b-grey-100 py-4 text-left text-sm font-bold last:border-b-0"
                onClick={() => {
                  item.onClick();
                  handleModalClose();
                }}
                key={`filter-${idx}-${item.value}`}
              >
                {item.name}
              </button>
            );
          })}
        </div>
      </FindEventsFilterModal>
    </>
  );
};
